import React, { useEffect, useState, useRef } from "react";
import { getAllUsers } from "../../../../pages/api/backlog";
import { createStory }  from "../../../../pages/api/adminDashboard";
import { toast }        from "react-toastify";
import { getPriorities, getCategories } from "../../../../pages/api/masterOptions";

/* ─── helpers ─── */
const labelStyle = {
  display: "block", fontSize: "11px", fontWeight: "700",
  color: "#6b7280", marginBottom: "6px",
  textTransform: "uppercase", letterSpacing: "0.06em",
};
const selectStyle = {
  width: "100%", border: "1px solid #d1d5db", borderRadius: "6px",
  padding: "9px 12px", fontSize: "14px", outline: "none",
  background: "#fff", color: "#111827", appearance: "none",
  backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E")`,
  backgroundRepeat: "no-repeat", backgroundPosition: "right 12px center",
  paddingRight: "32px", cursor: "pointer",
};
const tbBtn = (active) => ({
  background: active ? "#eff6ff" : "none",
  border: active ? "1px solid #bfdbfe" : "none",
  borderRadius: "4px", cursor: "pointer", padding: "3px 6px",
  color: active ? "#1d4ed8" : "#9ca3af",
  display: "flex", alignItems: "center", justifyContent: "center",
});

/* ════════════════════════════════════════════════════════════
   COMPONENT
════════════════════════════════════════════════════════════ */
const CreateTaskModal = ({ show, onClose, onSave, token }) => {
  /* form state */
  const [taskName,    setTaskName]    = useState("");
  const [description, setDescription] = useState("");
const [type,        setType]        = useState("");
  const [priority,    setPriority]    = useState("Medium");
  const [storyPoints, setStoryPoints] = useState(0);
  const [assignee,    setAssignee]    = useState("");
  const [users,       setUsers]       = useState([]);
  const [isSaving,    setIsSaving]    = useState(false);
  const [nameError,   setNameError]   = useState("");
  const [activeTab, setActiveTab] = useState("write");  // ← ADD THIS

  /* mention state — NO mentionPos */
  const [showMention,  setShowMention]  = useState(false);
  const [mentionQuery, setMentionQuery] = useState("");
  const [mentionStart, setMentionStart] = useState(-1);

  /* format state */
  const [showFmtMenu, setShowFmtMenu] = useState(false);

  /* attachment state */
  const [attachments, setAttachments] = useState([]);

  const fileInputRef = useRef(null);
  const textareaRef  = useRef(null);

 const [priorities, setPriorities] = useState([]);
  const [categories, setCategories] = useState([]);

  /* fetch priority + category */
  useEffect(() => {
    if (!show) return;
    getPriorities(token).then(res => setPriorities(res.data || [])).catch(() => {});
    getCategories(token).then(res => setCategories(res.data || [])).catch(() => {});
  }, [show, token]);

  /* fetch users */
  useEffect(() => {
    if (!show) return;
    (async () => {
      try {
        const res = await getAllUsers(token);
        if (res?.status === 200) setUsers(res.data || []);
      } catch (e) { console.error(e); }
    })();
  }, [show, token]);

  /* close dropdowns on outside click */
  useEffect(() => {
    const handler = (e) => {
      if (!e.target.closest(".mention-wrap"))  setShowMention(false);
      if (!e.target.closest(".fmt-menu-wrap")) setShowFmtMenu(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const reset = () => {
    setTaskName(""); setDescription(""); setType("Task");
    setPriority("Medium"); setStoryPoints(0); setAssignee("");
    setNameError(""); setAttachments([]);
    setShowMention(false); setShowFmtMenu(false);
  };
  const handleClose = () => { reset(); onClose(); };

  /* ── save ── */
  const handleSave = async () => {
    if (!taskName.trim()) { setNameError("Task name is required."); return; }
    setNameError("");
    setIsSaving(true);
    try {
      const storyData = {
        storyTitle:       taskName.trim(),
        storyDescription: description,
        storyType:        type,
        priority:         priority.toUpperCase(),
        storyPoints:      Number(storyPoints),
        status:           "BACKLOG",
...(assignee && { userIds: [Number(assignee)] }),      };
      const formData = new FormData();
      formData.append("story", JSON.stringify(storyData));
attachments.forEach((file) => formData.append("files", file));
      const res = await createStory(formData, token);
      if (res?.status === 200 || res?.status === 201) {
        toast.success("Task created successfully!");
        onSave && onSave();
        handleClose();
      } else {
        toast.error(res?.data?.message || "Failed to create task.");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err?.message || "An error occurred.");
    } finally {
      setIsSaving(false);
    }
  };

  /* ── @ mention: detect @ typed in textarea ── */
  const handleDescriptionChange = (e) => {
    const val   = e.target.value;
    const caret = e.target.selectionStart;
    setDescription(val);

    const textUpToCaret = val.slice(0, caret);
    const atIdx = textUpToCaret.lastIndexOf("@");
    if (atIdx !== -1) {
      const query = textUpToCaret.slice(atIdx + 1);
      if (!query.includes(" ")) {
        setMentionQuery(query);
        setMentionStart(atIdx);
        setShowMention(true);
        return;
      }
    }
    setShowMention(false);
  };

  const handleDescriptionKeyDown = (e) => {
    if (showMention && e.key === "Escape") {
      setShowMention(false);
      e.preventDefault();
    }
  };

  const filteredUsers = users.filter((u) =>
    `${u.firstName} ${u.lastName}`.toLowerCase().includes(mentionQuery.toLowerCase())
  );

  const insertMention = (user) => {
  const before  = description.slice(0, mentionStart);
  const after   = description.slice(mentionStart + 1 + mentionQuery.length);
  const firstName = user.firstName || "";
  const lastName  = user.lastName  || "";
  const fullName  = `${firstName} ${lastName}`.trim() || user.email || "Unknown";
  setDescription(before + `@${fullName} ` + after);
  setShowMention(false);
  textareaRef.current?.focus();
};

  /* ── formatting ── */
const applyFormat = (fmt) => {
  const ta = textareaRef.current;
  if (!ta) return;
  const start = ta.selectionStart;
  const end   = ta.selectionEnd;
  const sel   = description.slice(start, end);
  let replacement = sel;
  let cursorOffset = 0;

  if (fmt === "bold") {
    replacement  = `**${sel || "bold text"}**`;
    cursorOffset = replacement.length;
  } else if (fmt === "bullet") {
    replacement  = sel ? sel.split("\n").map((l) => `• ${l}`).join("\n") : "• ";
    cursorOffset = replacement.length;
  }

  setDescription(description.slice(0, start) + replacement + description.slice(end));
  setShowFmtMenu(false);
  requestAnimationFrame(() => {
    ta.focus();
    ta.setSelectionRange(start + cursorOffset, start + cursorOffset);
  });
};

  /* ── attachments ── */
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setAttachments((prev) => {
      const names = new Set(prev.map((f) => f.name));
      return [...prev, ...files.filter((f) => !names.has(f.name))];
    });
    e.target.value = "";
  };
  const removeAttachment = (name) =>
    setAttachments((prev) => prev.filter((f) => f.name !== name));

  /* ════════════════════════════════════════════════════════════
     RENDER
  ════════════════════════════════════════════════════════════ */
  if (!show) return null;

  return (
    <div
          style={{
        position: "fixed", inset: 0,
        background: "rgba(0,0,0,0.45)",
        zIndex: 1300,
        display: "flex", alignItems: "center", justifyContent: "center",
        padding: "16px",
        boxSizing: "border-box",
      }}
      onClick={handleClose}
    >
    <div
        style={{
          background: "#fff", borderRadius: "10px",
          width: "100%", maxWidth: "660px",
          boxShadow: "0 8px 40px rgba(0,0,0,0.18)",
          overflow: "visible",
          maxHeight: "90vh", overflowY: "auto",
          border: "2px solid #3b82f6",
          position: "relative", boxSizing: "border-box",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* ── Header ── */}
        <div style={{
          display: "flex", alignItems: "center", justifyContent: "space-between",
          padding: "14px 20px", borderBottom: "1px solid #e5e7eb",
          borderRadius: "10px 10px 0 0",
        }}>
          <span style={{ fontWeight: "700", fontSize: "16px", color: "#111827" }}>
            Create Task
          </span>
          <button onClick={handleClose} style={{
            background: "none", border: "none", fontSize: "20px",
            cursor: "pointer", color: "#6b7280", lineHeight: 1, padding: 0,
          }}>×</button>
        </div>

        {/* ── Body ── */}
        <div style={{ padding: "16px 20px", display: "flex", flexDirection: "column" }}>

          {/* TASK NAME */}
          <div style={{
            border: "1px solid #d1d5db", borderRadius: "6px 6px 0 0",
            padding: "10px 14px", borderBottom: "none",
          }}>
<label style={labelStyle}>TASK NAME <span style={{ color: "#dc2626" }}>*</span></label>
            <input
              type="text"
              placeholder="eg., Menu Revision"
              value={taskName}
              onChange={(e) => { setTaskName(e.target.value); setNameError(""); }}
              style={{
                width: "100%", border: "none", outline: "none",
                fontSize: "14px", color: "#111827",
                background: "transparent", padding: "2px 0",
              }}
            />
            {nameError && (
              <div style={{ color: "#e53935", fontSize: "12px", marginTop: "2px" }}>{nameError}</div>
            )}
          </div>

          {/* DESCRIPTION + TOOLBAR */}
<div style={{ border: "1px solid #d1d5db", borderBottom: "none", position: "relative" }}>
  <div style={{ padding: "10px 14px 4px 14px" }}>
    <label style={labelStyle}>DESCRIPTION</label>

    {/* Write / Preview toggle */}
    {activeTab === "write" ? (
      <textarea
        ref={textareaRef}
        placeholder="Context... (type @ to mention someone)"
        value={description}
        onChange={handleDescriptionChange}
        onKeyDown={handleDescriptionKeyDown}
        rows={4}
        style={{
          width: "100%", border: "none", outline: "none",
          fontSize: "14px", color: "#111827", background: "transparent",
          resize: "vertical", padding: "2px 0", fontFamily: "inherit",
          minHeight: "80px", boxSizing: "border-box",
        }}
      />
    ) : (
      <div
        style={{
          minHeight: "80px", fontSize: "14px", color: "#374151",
          padding: "2px 0", lineHeight: "1.6",
        }}
        dangerouslySetInnerHTML={{
  __html: description
    ? description
        .replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>")  // **bold**
        .replace(/\*(.*?)\*/g, "<em>$1</em>")               // *italic*
        .replace(/• /g, "• ")                               // bullets
        .replace(/\n/g, "<br/>")                            // newlines
    : '<span style="color:#9ca3af">Nothing to preview</span>',
}}
      />
    )}
  </div>

  {/* ── TOOLBAR ── */}
  <div style={{
    display: "flex", alignItems: "center", gap: "6px",
    padding: "6px 14px 10px 14px",
    borderTop: "1px solid #f3f4f6",
    flexWrap: "wrap",
  }}>

    {/* ① @ MENTION BUTTON */}
    <div className="mention-wrap" style={{ position: "relative" }}>
      <button
        title="Mention a team member"
        style={tbBtn(showMention)}
        onClick={() => {
          const ta    = textareaRef.current;
          const caret = ta ? ta.selectionStart : description.length;
          const charBefore = description[caret - 1];
          if (charBefore === "@") {
            setMentionStart(caret - 1);
            setMentionQuery("");
            setShowMention((p) => !p);
            return;
          }
          const before = description.slice(0, caret);
          const after  = description.slice(caret);
          setDescription(before + "@" + after);
          setMentionStart(caret);
          setMentionQuery("");
          setShowMention(true);
          setTimeout(() => {
            ta?.focus();
            ta?.setSelectionRange(caret + 1, caret + 1);
          }, 0);
        }}
      >
        <span style={{
          fontSize: "14px", fontWeight: "600",
          color: showMention ? "#1d4ed8" : "#9ca3af",
        }}>@</span>
      </button>

      {showMention && (
        <div style={{
          position: "absolute", top: "calc(100% + 6px)", left: 0,
          background: "#fff", border: "1px solid #e5e7eb",
          borderRadius: "8px", boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
          zIndex: 1400, minWidth: "220px", maxHeight: "200px", overflowY: "auto",
        }}>
          <div style={{
            padding: "6px 12px 4px", fontSize: "10px", fontWeight: "700",
            color: "#9ca3af", textTransform: "uppercase", letterSpacing: ".06em",
          }}>
            Mention a member
          </div>
          {filteredUsers.length === 0 && (
            <div style={{ padding: "10px 12px", fontSize: "13px", color: "#9ca3af" }}>
              No members found
            </div>
          )}
          {filteredUsers.map((u) => {
            const initials = ((u.firstName?.[0] || "") + (u.lastName?.[0] || "")) || (u.email?.[0] || "?");
            return (
              <div
                key={u.id}
                onMouseDown={(e) => { e.preventDefault(); insertMention(u); }}
                style={{
                  display: "flex", alignItems: "center", gap: "10px",
                  padding: "8px 12px", cursor: "pointer",
                  borderBottom: "1px solid #f3f4f6",
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = "#f9fafb"}
                onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
              >
                <div style={{
                  width: "30px", height: "30px", borderRadius: "50%",
                  background: "#1d4ed8", color: "#fff",
                  fontSize: "11px", fontWeight: "700",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  flexShrink: 0,
                }}>
                  {initials.toUpperCase()}
                </div>
                <div>
                  <div style={{ fontSize: "13px", fontWeight: "600", color: "#111827" }}>
                    {[u.firstName, u.lastName].filter(Boolean).join(" ") || u.email || "Unknown"}
                  </div>
                  {u.email && (
                    <div style={{ fontSize: "11px", color: "#9ca3af" }}>{u.email}</div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>

    {/* ② ATTACH BUTTON */}
    <button
      title="Attach files"
      style={tbBtn(attachments.length > 0)}
      onClick={() => fileInputRef.current?.click()}
    >
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
        stroke={attachments.length > 0 ? "#1d4ed8" : "#9ca3af"} strokeWidth="2">
        <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
      </svg>
      {attachments.length > 0 && (
        <span style={{
          marginLeft: "4px", background: "#1d4ed8", color: "#fff",
          borderRadius: "10px", fontSize: "10px",
          fontWeight: "700", padding: "1px 5px",
        }}>
          {attachments.length}
        </span>
      )}
    </button>
    <input
      ref={fileInputRef}
      type="file" multiple
      accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.txt,.zip"
      style={{ display: "none" }}
      onChange={handleFileChange}
    />

    {/* ③ FORMAT BUTTON */}
    <div className="fmt-menu-wrap" style={{ position: "relative" }}>
      <button
        title="Text formatting"
        style={tbBtn(showFmtMenu)}
        onClick={() => setShowFmtMenu((p) => !p)}
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke={showFmtMenu ? "#1d4ed8" : "#9ca3af"} strokeWidth="2">
          <line x1="8"  y1="6"  x2="21"   y2="6"  />
          <line x1="8"  y1="12" x2="21"   y2="12" />
          <line x1="8"  y1="18" x2="21"   y2="18" />
          <line x1="3"  y1="6"  x2="3.01" y2="6"  />
          <line x1="3"  y1="12" x2="3.01" y2="12" />
          <line x1="3"  y1="18" x2="3.01" y2="18" />
        </svg>
      </button>
      {showFmtMenu && (
        <div style={{
          position: "absolute", top: "calc(100% + 6px)", left: 0,
          background: "#fff", border: "1px solid #e5e7eb",
          borderRadius: "8px", boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
          zIndex: 1400, minWidth: "160px", padding: "4px 0",
        }}>
          {[
  { key: "bold",   label: "Bold",        hint: "**text**", icon: "B" },
  { key: "bullet", label: "Bullet list", hint: "• item",   icon: "•" },
].map((f) => (
            <button
              key={f.key}
              onClick={() => applyFormat(f.key)}
              style={{
                display: "flex", alignItems: "center", gap: "10px",
                width: "100%", padding: "8px 14px",
                background: "none", border: "none",
                cursor: "pointer", fontSize: "13px",
                color: "#374151", textAlign: "left",
              }}
              onMouseEnter={(e) => e.currentTarget.style.background = "#f9fafb"}
              onMouseLeave={(e) => e.currentTarget.style.background = "none"}
            >
              <span style={{
  width: "22px", height: "22px", background: "#f3f4f6",
  borderRadius: "4px", display: "flex",
  alignItems: "center", justifyContent: "center",
  fontSize: f.key === "bullet" ? "16px" : "13px",
  fontWeight: f.key === "bold" ? "700" : "400",
  color: "#374151", flexShrink: 0,
}}>{f.icon}</span>
              <div>
                <div style={{ fontWeight: "500" }}>{f.label}</div>
                <div style={{ fontSize: "11px", color: "#9ca3af" }}>{f.hint}</div>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>

    {/* ④ Write / Preview toggle — pushed to right */}
    <div style={{ marginLeft: "auto", display: "flex", gap: "2px" }}>
      {["write", "preview"].map((t) => (
        <button
          key={t}
          onClick={() => setActiveTab(t)}
          style={{
            background: activeTab === t ? "#e5e7eb" : "none",
            border: "none", borderRadius: "4px",
            padding: "3px 10px", fontSize: "12px",
            color: activeTab === t ? "#111827" : "#6b7280",
            fontWeight: activeTab === t ? "600" : "400",
            cursor: "pointer",
          }}
        >
          {t.charAt(0).toUpperCase() + t.slice(1)}
        </button>
      ))}
    </div>
  </div>

  {/* Attachment chips */}
  {attachments.length > 0 && (
    <div style={{
      padding: "0 14px 10px 14px",
      display: "flex", flexWrap: "wrap", gap: "6px",
    }}>
      {attachments.map((file) => (
        <div key={file.name} style={{
          display: "flex", alignItems: "center", gap: "5px",
          background: "#eff6ff", border: "1px solid #bfdbfe",
          borderRadius: "4px", padding: "3px 8px",
          fontSize: "12px", color: "#1d4ed8",
        }}>
          <span style={{
            maxWidth: "140px", overflow: "hidden",
            textOverflow: "ellipsis", whiteSpace: "nowrap",
          }}>
            {file.name}
          </span>
          <button
            onClick={() => removeAttachment(file.name)}
            style={{
              background: "none", border: "none", cursor: "pointer",
              color: "#6b7280", fontSize: "13px", lineHeight: 1, padding: 0,
            }}
          >×</button>
        </div>
      ))}
    </div>
  )}
</div>

          {/* TYPE + PRIORITY */}
          <div style={{
            display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
            border: "1px solid #d1d5db", borderBottom: "none",
          }}>
            <div style={{ padding: "10px 14px", borderRight: "1px solid #d1d5db" }}>
              <label style={labelStyle}>CATEGORY</label>
              <select value={type} onChange={(e) => setType(e.target.value)} style={selectStyle}>
                <option value="">Select Category</option>
                {categories.map((c) => (
                  <option key={c.id} value={c.category}>{c.category}</option>
                                  ))}
              </select>
            </div>
            <div style={{ padding: "10px 14px" }}>
              <label style={labelStyle}>PRIORITY</label>
              <select value={priority} onChange={(e) => setPriority(e.target.value)} style={selectStyle}>
                {[...priorities].reverse().map((p) => (
                  <option key={p.id} value={p.priority}>{p.priority}</option>
                ))}
              </select>
            </div>
          </div>

          {/* Empty div to close the form sections properly */}
          <div style={{
            display: "none",
            border: "1px solid #d1d5db", borderRadius: "0 0 6px 6px",
          }} />
        </div>

        {/* ── Footer ── */}
        <div style={{
          display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "10px",
          padding: "12px 20px", borderTop: "1px solid #e5e7eb",
        }}>
          <button onClick={handleClose} style={{
            padding: "8px 24px", border: "1px solid #d1d5db",
            borderRadius: "6px", background: "#fff",
            cursor: "pointer", fontSize: "14px", color: "#374151",
          }}>Cancel</button>
          <button onClick={handleSave} disabled={isSaving} style={{
            padding: "8px 24px", border: "none", borderRadius: "6px",
            background: "#2E5CB8", color: "#fff", cursor: "pointer",
            fontSize: "14px", fontWeight: "600", opacity: isSaving ? 0.7 : 1,
          }}>
            {isSaving ? "Creating..." : "Create Task"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateTaskModal;
